declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_spread_keep2_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_spread_keep2 extends $bog_fragile_demo_spread_base2 {
		Extra( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=keep2.view.tree.d.ts.map